<template>
  <div>
    <div id="articulos">
      <div id="hidden-message" style="display:none;">
        <PostNotFound/>  
      </div>
      
      <VueSlickCarousel v-if="articulos.length >0" v-bind="settings">
        <div v-for="articulo in articulos" :value="articulo.value" :key="articulo.value" class="col-lg-12 article">
          <b-link :to="'blog/articulo/' +  articulo.id">
            <div>
              <img :src="url + articulo.imagen">
              <p>{{articulo.titulo}}</p>
              <b-link :to="'blog/articulo/' +  articulo.id">Leer más <b-icon icon="chevron-right" class="ml-2 chevron"></b-icon></b-link>
            </div> 
          </b-link>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>

import env from '@/plugins/enviroment';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import PostNotFound from '@/components/post-not-found.vue';
import postsApi from "../api/posts";
import {mapState} from "vuex"; 

// optional style for arrows & dots




export default {
  data() {
    return {
      articulos:[],
      cat_id:null,
      titulo_art:"",
      urlImg:"",
      settings:{
  "dots": true,
  "infinite": false,
  "speed": 500,
  "slidesToShow": 4,
  "slidesToScroll": 4,
  "responsive": [
    {
      "breakpoint": 1024,
      "settings": {
        "slidesToShow": 3,
        "slidesToScroll": 3,
        "infinite": false,
        "dots": true
      }
    },
    {
      "breakpoint": 480,
      "settings": {
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "infinite":false,
        "dots":false
      }
    }
  ]
}
    }
  },
  components: {
    PostNotFound,
    VueSlickCarousel
  },
  computed: {
    ...mapState("posts",['categoria_id','titulo']),
  },
  watch: {
    categoria_id(newValue, oldValue) {
      this.cat_id = newValue;
      this.getPosts();
    },
    titulo(newValue, oldValue){
      this.titulo_art = newValue;
      this.getPosts();
    }
  },
  methods: {
    isMobile() {
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    getPosts(page){
      /*
      -PARAMETROS PERMITIDOS-
        categoria_id=1
        titulo=conta
        tipo=posts
        fecha_publicacion=2020-10-02
        min_fecha_publicacion=2020-10-02
        max_fecha_publicacion=2020-10-03
        activo=true
        paginate=true
        items_to_show=10
        order=asc
        order_by=fecha_publicacion
        -------------------------*/

      let parametros = {categoria_id:this.cat_id,titulo:this.titulo_art,activo: true,paginate:false,items_to_show:10,order:"desc",order_by:"fecha_publicacion"};
      postsApi
      .getPosts(parametros)
      .then(response => {

        this.articulos = response.data.data;
        
        var message = document.getElementById("hidden-message");
       
        if(this.articulos.length == 0){
          message.style.display="inline";
        }else{
          message.style.display="none";
        }
        
      }).catch(err => {
        console.log("Ocurrio un error al cargar los articulos.");
      });
    }
  },mounted () {
      
    },
  created () {
    this.url = env.baseURL;
    this.getPosts();
  },
}
</script>

<style scoped>  

  .article{
    margin-bottom:auto;
    text-align: left;
  }
  .article > a{
    text-decoration: none;
  }
  .article div{
    margin:0px 0px 10px 0px;
    padding-bottom:15px;
    transition: 0.3s;
  }
  .article:hover div{
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  }
  .article img {
    width: 100%;  
    height: 29vh;
    border-radius: 10px;
  }

  .article p {
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 25px;
    color: #1E2245;
    padding:15px;
    height: 140px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 10px;
  }

  .article a{
    padding-left:15px ;
    margin-top:-20px;
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #1E2245;
  }

  @media(max-width: 768px){
  .article img {
    height: 35vh;
  }

    
  }

</style>
